// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"56e193af9150d1a0","5620":"fd3712792a10a512"}[chunkId] + ".css";
};